export const TOAST_ERROR_ACTION = "TOAST_ERROR_ACTION";
export const TOAST_INFO_ACTION = "TOAST_INFO_ACTION";
export const TOAST_WARN_ACTION = "TOAST_WARN_ACTION";
export const TOAST_SUCCESS_ACTION = "TOAST_SUCCESS_ACTION";
export const HIDE_TOAST_ACTION = "HIDE_TOAST_ACTION";
